import { ErrorHandler, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler {
    handleError(error: any): void {
        const message = error?.message || (typeof error === 'string' ? error : '');

        // Check for chunk loading errors or dynamic import failures.
        // These usually happen when Cloudflare Access session expires and redirects the JS fetch to a login page,
        // or when a new version is deployed and old chunks are missing.
        if (
            message.includes('Failed to fetch dynamically imported module') ||
            message.includes('ChunkLoadError') ||
            message.includes('Loading chunk') ||
            message.includes('error loading chunk') ||
            (error instanceof TypeError && message.includes('fetch'))
        ) {
            console.warn('Dynamic import or chunk loading failed. Possible session expiration or new deployment. Reloading...', {
                message,
                error
            });

            // Force a reload to trigger Cloudflare Access redirect or fetch new index.html
            window.location.reload();
            return;
        }

        // Always log the error to the console for debugging
        console.error('Global Error Handler:', error);
    }
}
